import { Field } from 'react-final-form';
import FieldTextInput from '../../FieldTextInput/FieldTextInput';
import { useIntl } from 'react-intl';
import css from './InquiryForm.module.css';

const InquiryForm = ({submitFailed}) => {
  const intl = useIntl();

  return (
    <div className={css.gridContainer}>
      <FieldTextInput
        name="firstName"
        placeholder={intl.formatMessage({ id: 'ContactForm.firstName' }) + ' *'}
      />

      <FieldTextInput
        name="lastName"
        placeholder={intl.formatMessage({ id: 'ContactForm.lastName' }) + ' *'}
      />

      <FieldTextInput
        name="email"
        placeholder={intl.formatMessage({ id: 'ContactForm.email' }) + ' *'}
      />

      <FieldTextInput
        name="phoneNumber"
        placeholder={intl.formatMessage({ id: 'ContactForm.phoneNumber' }) + ' *'}
      />

      <Field
        name="message"
        render={({ input, meta }) => (
          <div className={css.message}>
            <textarea
              {...input}
              placeholder={intl.formatMessage({ id: 'ContactForm.message' }) + ' *'}
            />
            {meta.touched && meta.error && (
              <div className={css.errorText}>Dieses Feld ist erforderlich.</div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default InquiryForm;
